import React, { useEffect, useState } from "react";


import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, } from "@mui/material";
import { Form, Input, message, Modal, Select } from "antd";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { Dropdown, Menu, Button } from "antd";
import { MoreOutlined } from '@ant-design/icons';


import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom, Upcoming } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { VEH_IMAGE_URL } from "../../Api/constants";

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TextField,
} from '@mui/material';
import DataTable from "../../Components/DataTable";
import { capitalizeFirstLetter } from "../../config/functions";


const { Option } = Select;




const UpcomingMots = () => {


    const { id } = useParams();

    const theme = useTheme();
    const dispatch = useDispatch();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const user = useSelector((state) => state.authReducer.user);

    const [vehicle, setVehicle] = useState([]);
    const [requests, setRequests] = useState([]);

    const [activeTab, setActiveTab] = React.useState('allBookings');
    const [pending, setPending] = useState([]);
    const [approved, setApproved] = useState([]);
    const [rejected, setRejected] = useState([]);
    const [returned, setReturned] = useState([]);
    const [data, setData] = useState([]);
    const [deletedId, setDeletedId] = useState('');
    const [deletedModal, setDeletedModal] = useState(false);



    const history = useNavigate();


    const getBookingRequests = async () => {

        const onSuccess = (res) => {
            setRequests(res.data);
            setData(res.data);
            console.log('approved_booking_requests', res.approved_booking_requests)
            setPending(res.pending_booking_requests);
            setApproved(res.approved_booking_requests);
            setRejected(res.rejected_booking_requests);
            setReturned(res.returned_booking_requests);
            console.log('res.data', res.data);
        }

        const onError = (err) => {
            console.log('err', err);
            message.error('error')
        }

        dispatch(setLoader(true));
        const body = {
            token: user?.token
            // user?.token
        }

        await postRequest(body, apiRoutes.getUpcomingMots, onSuccess, onError)

    }

    const checkBookingStatusForApprove = async (id, cb = () => { }) => {

        dispatch(setLoader(true));
        const body = {
            token: user?.token,
            booking_id: id
        }
        console.log('body___', body);

        const res = await postRequest(body, apiRoutes.checkBookingStatusForApprove);
        if (res.status == '1') return true;
        else return {
            status: false,
            message: res.error
        }
    }

    const deleteBookingRequest = async () => {
        const onSuccess = (res) => {
            message.success('Deleted!');
            setDeletedId('')
            getBookingRequests();
        }

        const onError = (err) => {
            console.log('err', err);
            setDeletedId('')
            // alert(err)
        }

        dispatch(setLoader(true));
        const body = {
            token: user?.token,
            booking_id: deletedId
        };

        await postRequest(body, apiRoutes.deleteBookingRequest, onSuccess, onError);

    }

    const handleActionClick = async (key, record) => {
        history(`/edit-vehicle/${record.veh_id}`);
        return;
    };

    const changeTab = (type) => {
        setActiveTab(type);
        if (type == 'allBookings') {
            setData(requests);
        }
        else if (type == 'pending') {
            setData(pending);
        }
        else if (type == 'approved') {
            setData(approved);
        }
        else if (type == 'rejected') {
            setData(rejected);
        }
        else if (type == 'returned') {
            setData(returned);
        }
    }





    const columns = [
        {
            title: 'Veh name',
            dataIndex: 'veh_name',
            key: 'name',
            render: (text, record) => <Link
                style={{ color: appColors.primary, textDecoration: 'underline', fontFamily: 'Poppins', }}
                to={{
                    pathname: `/vehicle-details/${record?.veh_id}`,
                    state: record,
                }}
            >
                {text}
            </Link>,
        },
        {
            title: 'Reg no',
            dataIndex: 'reg_no',
            key: 'reg_no',
        },
        {
            title: 'Model',
            dataIndex: 'model',
            key: 'model',
        },
        {
            title: 'Rent',
            dataIndex: 'rent',
            key: 'rent',
        },

        {
            title: 'MOT test date',
            dataIndex: 'mot_test_date',
            key: 'mot_test_date',
            render: (_, record) => (
                <div>
                    <Typography style={{ fontSize: 12, color: appColors.black, fontFamily: 'Poppins', }}>
                        {new Date(record.mot_test_date).toLocaleDateString()}
                    </Typography>

                </div>
            ),
        },
        {
            title: 'MOT Exp date',
            dataIndex: 'mot_exp_date',
            key: 'mot_exp_date',
            render: (_, record) => (
                <div>
                    <Typography style={{ fontSize: 12, color: appColors.black, fontFamily: 'Poppins', }}>
                        {new Date(record.mot_exp_date).toLocaleDateString()}
                    </Typography>

                </div>
            ),
        },

        {
            title: 'Days remaining',
            dataIndex: 'days_remaining',
            key: 'days_remaining',
            render: (_, record) => (
                <div>
                    <Typography style={{ fontSize: 12, color: record.days_remaining < 2 ? 'red' : appColors.black, fontFamily: 'Poppins', }}>
                        {record.days_remaining}
                    </Typography>

                </div>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Dropdown
                    overlay={


                        <Menu onClick={({ key }) => handleActionClick(key, record)}>
                            <Menu.Item key="edit">Edit</Menu.Item>
                        </Menu>
                    }
                    trigger={['click']}
                >
                    <Button>
                        <MoreOutlined style={{ fontWeight: 'bolder' }} />
                    </Button>
                </Dropdown>
            ),

        },
    ];



    useEffect(() => {
        getBookingRequests()
    }, [])


    return (
        <>
            <ThemeProvider theme={theme}>

                <Modal
                    title="Are you sure you want to delete this booking request?"
                    visible={deletedModal}
                    onCancel={() => setDeletedModal(false)}
                    footer={[
                        <Button key="cancel" onClick={() => {
                            setDeletedModal(false);
                            setDeletedId('');
                        }}>
                            Cancel
                        </Button>,
                        <Button danger key="delete" onClick={() => {
                            setDeletedModal(false);
                            deleteBookingRequest();
                        }}>
                            Delete
                        </Button>,
                    ]}
                >
                    {/* <p>Deleting this note will parmanently delete. You will never recover this note.</p> */}
                </Modal>

                <div style={{ display: 'flex', }}>
                    <Sidebars />
                    <div style={{ marginLeft: 10 }}>
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Upcoming Mots
                        </span>
                        <div>
                            <DataTable data={data} columns={columns} />
                        </div>
                    </div>



                </div>
            </ThemeProvider>
        </>
    )

}

const tabContainer = {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'white',
    width: 420,
    borderRadius: 15,
    paddingTop: 10, paddingRight: 20, paddingLeft: 20,
    justifyContent: 'space-between',
    boxShadow: '0px 4px 4px rgba(31, 31, 31, 0.1)',


}
const tabText = {
    fontSize: 14,
    color: '#000000',
    fontFamily: 'Poppins',


}

const focusedTabLine = {
    backgroundColor: appColors.primary,
    width: 55,
    height: 2,
    marginTop: 5

}

export default UpcomingMots
